import React, { FunctionComponent } from 'react';
import { Box, Heading } from '@chakra-ui/react';

const JobListingHeader: FunctionComponent = () => (
  <Box mb="24" mx="auto" maxW="900px" textAlign="center">
    <Heading as="h2" size="3xl">
      Open Roles
    </Heading>
  </Box>
);
export default JobListingHeader;
